"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FundraisingTimeFrameMonths = exports.USE_OF_FUNDS_OPTIONS = exports.USE_OF_FUNDS = exports.UseOfFunds = exports.FundingType = exports.LastFundingRound = void 0;
const legacy_ui_1 = require("@hum/legacy-ui");
var LastFundingRound;
(function (LastFundingRound) {
    LastFundingRound["Bootstrapped"] = "bootstrapped";
    LastFundingRound["PreSeed"] = "preseed";
    LastFundingRound["Seed"] = "seed";
    LastFundingRound["SeriesA"] = "series_a";
    LastFundingRound["SeriesB"] = "series_b";
    LastFundingRound["SeriesC"] = "series_c";
    LastFundingRound["SeriesD"] = "series_d";
    LastFundingRound["SeriesE"] = "series_e";
})(LastFundingRound = exports.LastFundingRound || (exports.LastFundingRound = {}));
var FundingType;
(function (FundingType) {
    FundingType["Debt"] = "debt";
    FundingType["Equity"] = "equity";
    FundingType["Either"] = "either";
    FundingType["IDontKnow"] = "i_dont_know";
})(FundingType = exports.FundingType || (exports.FundingType = {}));
var UseOfFunds;
(function (UseOfFunds) {
    UseOfFunds["OrganicGrowth"] = "organic_growth";
    UseOfFunds["ResearchAndDevelopment"] = "research_and_development";
    UseOfFunds["InventoryOrWorkingCapital"] = "inventory_or_working_capital";
    UseOfFunds["PurchaseOrders"] = "purchase_orders";
    UseOfFunds["Payables"] = "payables";
    UseOfFunds["TurnaroundFinancing"] = "turnaround_financing";
    UseOfFunds["CapitalEquipment"] = "capital_equipment";
    UseOfFunds["RealEstate"] = "real_estate";
    UseOfFunds["Acquisition"] = "acquisition";
    UseOfFunds["Lending"] = "lending";
    UseOfFunds["Recapitalization"] = "recapitalization";
    UseOfFunds["DebtRefinancing"] = "debt_refinancing";
    UseOfFunds["Other"] = "other";
})(UseOfFunds = exports.UseOfFunds || (exports.UseOfFunds = {}));
exports.USE_OF_FUNDS = {
    [UseOfFunds.Acquisition]: 'Acquisition',
    [UseOfFunds.CapitalEquipment]: 'Capital Equipment',
    [UseOfFunds.DebtRefinancing]: 'Debt Refinancing',
    [UseOfFunds.InventoryOrWorkingCapital]: 'Inventory or Working Capital',
    [UseOfFunds.Lending]: 'Lending',
    [UseOfFunds.OrganicGrowth]: 'Organic Growth',
    [UseOfFunds.Payables]: 'Payables',
    [UseOfFunds.PurchaseOrders]: 'Purchase Orders',
    [UseOfFunds.ResearchAndDevelopment]: 'R&D',
    [UseOfFunds.RealEstate]: 'Real Estate',
    [UseOfFunds.Recapitalization]: 'Recapitalization',
    [UseOfFunds.TurnaroundFinancing]: 'Turnaround Financing',
    [UseOfFunds.Other]: 'Other',
};
exports.USE_OF_FUNDS_OPTIONS = (0, legacy_ui_1.selectOptionsFromMap)({
    [UseOfFunds.Acquisition]: 'Acquisition',
    [UseOfFunds.CapitalEquipment]: 'Capital Equipment',
    [UseOfFunds.DebtRefinancing]: 'Debt Refinancing',
    [UseOfFunds.InventoryOrWorkingCapital]: 'Inventory or Working Capital',
    [UseOfFunds.Lending]: 'Lending',
    [UseOfFunds.OrganicGrowth]: 'Organic Growth',
    [UseOfFunds.Payables]: 'Payables',
    [UseOfFunds.PurchaseOrders]: 'Purchase Orders',
    [UseOfFunds.ResearchAndDevelopment]: 'R&D',
    [UseOfFunds.RealEstate]: 'Real Estate',
    [UseOfFunds.Recapitalization]: 'Recapitalization',
    [UseOfFunds.TurnaroundFinancing]: 'Turnaround Financing',
    [UseOfFunds.Other]: 'Other',
});
var FundraisingTimeFrameMonths;
(function (FundraisingTimeFrameMonths) {
    FundraisingTimeFrameMonths["Between0and3"] = "between_0_and_3_months";
    FundraisingTimeFrameMonths["Between3and6"] = "between_3_and_6_months";
    FundraisingTimeFrameMonths["Between6and12"] = "between_6_and_12_months";
    FundraisingTimeFrameMonths["MoreThan12"] = "more_than_12_months";
})(FundraisingTimeFrameMonths = exports.FundraisingTimeFrameMonths || (exports.FundraisingTimeFrameMonths = {}));
//# sourceMappingURL=funding.js.map